<script setup lang="ts">
import HandleQueryStatus from "@/components/HandleQueryStatus.vue";
import ManagementLayout from "@/layouts/ManagementLayout.vue";
import UserForm from "@/users/UserForm.vue";
import { useGetUser, useUpdateUser } from "./usersCrud";

const props = defineProps<{
  id: string;
}>();

const { user, getUserStatus } = useGetUser(props.id);
const { updateUser, updateUserStatus } = useUpdateUser();
</script>

<template>
  <ManagementLayout
    :breadcrumbs="[
      { label: 'Nutzer:innen', to: { name: 'users' } },
      { label: user?.name ?? '...' },
    ]"
  >
    <template #header>
      <h1>Nutzer:in bearbeiten</h1>
    </template>

    <HandleQueryStatus :query-status="getUserStatus">
      <UserForm
        v-if="user !== undefined"
        :saving-status="updateUserStatus"
        :user="user"
        @update="updateUser"
      />
    </HandleQueryStatus>
  </ManagementLayout>
</template>
